import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { ModalIsland, Button, Typography, OverlayProvider } from '@saviynt/design-system';
import { isLoggedIn } from '@saviynt/common';
import './SessionTimeout.css';

function SessionTimeout() {
  const intl = useIntl();
  const shouldRedirect = isLoggedIn();
  const isExtendError = new URLSearchParams(window.location.search).get('reason') === 'extendError';

  const gotToLogin = () => {
    window.location.href = '/';
  };

  useEffect(() => {
    if (shouldRedirect) {
      // This should ideally be handled by routes
      window.location.href = '/';
    }
  }, []);

  useEffect(() => {
    document.title = intl.formatMessage({
      id: 'SessionTimeout.title',
      defaultMessage: 'Session Timeout',
    });
  }, [intl]);

  // Prevent showing the logout UI on redirect
  if (shouldRedirect) {
    return null;
  }

  return (
    <OverlayProvider>
      <ModalIsland
        kind="critical"
        isOpen
        onClose={gotToLogin}
        HeaderComp={
          <>
            <Typography kind="h2" className="SessionTimeout-title">
              <FormattedMessage id="SessionTimeout.title" defaultMessage="Session Timeout" />
            </Typography>
            <Typography kind="body3" className="SessionTimeout-timer">
              {isExtendError ? (
                <FormattedMessage
                  id="SessionTimeout.extendError"
                  defaultMessage="An error occurred while trying to extend your session."
                />
              ) : (
                <FormattedMessage
                  id="SessionTimeout.message"
                  defaultMessage="You have been logged out due to inactivity."
                />
              )}
            </Typography>
          </>
        }
        primaryButton={
          <Button kind="filled" size="medium" onClick={gotToLogin}>
            <FormattedMessage id="SessionTimeout.login" defaultMessage="Login" />
          </Button>
        }
        secondaryButton={null}
      />
    </OverlayProvider>
  );
}

export default SessionTimeout;
